import { ThunderDispatcher } from '@nu-art/thunderstorm-frontend';
export const dispatch_OnAdvisorAnalyticsEventSent = new ThunderDispatcher('__onAdvisorAnalyticsEventSent');
//# sourceMappingURL=dispatch.js.map